// ============================================
// components/legal/PrivacyPolicy.js
// ============================================
import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import Layout from '../common/Layout';

const PrivacyPolicy = () => {
  return (
    <Layout title="Privacy Policy" showLogout={false} showBack>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Box>
          <Typography variant="h4" color="primary" gutterBottom>
            Privacy Policy
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>

          <Typography color="primary" paragraph>
            Porchlight respects your privacy. This Privacy Policy explains what
            information we collect, how we use it, and your rights related to
            that information.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>1. Information We Collect</Typography>
          <Typography color="primary" paragraph>
            We collect limited personal information necessary to operate the
            service:
          </Typography>
          <Box component="ul" sx={{ color: 'primary.main' }}>
            <li>Email address, first name, and last name when you sign up</li>
            <li>Authentication information through Firebase Authentication</li>
            <li>Device tokens for push notifications</li>
            <li>Friend connections and porchlight availability status you
            choose to share</li>
          </Box>

          <Typography variant="h6" color="primary" gutterBottom>2. How We Use Information</Typography>
          <Typography color="primary" paragraph>
            We use the information we collect to:
          </Typography>
          <Box component="ul" sx={{ color: 'primary.main' }}>
            <li>Provide and improve the Porchlight service</li>
            <li>Authenticate and secure your account</li>
            <li>Send you notifications when your friends interact with you</li>
            <li>Maintain service reliability and performance</li>
          </Box>

          <Typography variant="h6" color="primary" gutterBottom>3. Data Sharing</Typography>
          <Typography color="primary" paragraph>
            We do not sell your personal data. We only share information:
          </Typography>
          <Box component="ul" sx={{ color: 'primary.main' }}>
            <li>With your friends, to the extent you select them as viewers of
            your porchlight status</li>
            <li>With trusted service providers (like Firebase) who help us
            operate the app</li>
            <li>When required by law or to protect our rights</li>
          </Box>

          <Typography variant="h6" color="primary" gutterBottom>4. Data Retention</Typography>
          <Typography color="primary" paragraph>
            We retain your account data for as long as you maintain an account.
            You may request deletion of your account at any time from within the
            app or by contacting support. Upon deletion, we remove personal data
            except where retention is legally required.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>5. Your Choices</Typography>
          <Typography color="primary" paragraph>
            You can:
          </Typography>
          <Box component="ul" sx={{ color: 'primary.main' }}>
            <li>Access, update, or delete your account information</li>
            <li>Control push notifications through your device settings or in
            the app</li>
            <li>Request complete deletion of your account and data</li>
          </Box>

          <Typography variant="h6" color="primary" gutterBottom>6. Children’s Privacy</Typography>
          <Typography color="primary" paragraph>
            Porchlight is not directed to children under 13 (or the minimum age
            in your jurisdiction). We do not knowingly collect information from
            children without parental consent.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>7. Changes to This Policy</Typography>
          <Typography color="primary" paragraph>
            We may update this Privacy Policy from time to time. If we make
            material changes, we will notify you in the app or by email. Your
            continued use of Porchlight after changes indicates acceptance.
          </Typography>

          <Typography variant="h6" color="primary" gutterBottom>8. Contact</Typography>
          <Typography color="primary" paragraph>
            If you have any questions about this Privacy Policy or your data,
            please contact us at support@example.com.
          </Typography>
        </Box>
      </Container>
    </Layout>
  );
};

export default PrivacyPolicy;
